var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25075 7.5H9.75075V11.25H8.25075V7.5ZM8.25 12H9.75V13.5H8.25V12Z",
    fill: "#E44258"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.326 3.15002C10.065 2.65877 9.55646 2.35352 8.99996 2.35352C8.44346 2.35352 7.93496 2.65877 7.67396 3.15077L2.17046 13.548C2.04834 13.7763 1.98784 14.0326 1.99495 14.2914C2.00205 14.5502 2.0765 14.8027 2.21096 15.024C2.34349 15.2463 2.53169 15.4302 2.757 15.5575C2.98231 15.6848 3.23692 15.7512 3.49571 15.75H14.5042C15.0352 15.75 15.516 15.4785 15.7897 15.024C15.924 14.8027 15.9983 14.5502 16.0054 14.2914C16.0125 14.0326 15.9521 13.7764 15.8302 13.548L10.326 3.15002ZM3.49571 14.25L8.99996 3.85277L14.508 14.25H3.49571Z",
    fill: "#E44258"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.cb7fdbb6170c372d46ca6c0723736fdc.svg";
export { ForwardRef as ReactComponent };